import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import CheeseDrip from '../assets/img/drip.svg';

const TapButtonPanel = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  bottom: 108px;
  left: 0;
  width: 100%;
  padding: 16px;
  background: #FFFFFF;
  gap: 12px;
  flex-wrap: wrap;
  box-sizing: border-box;
`;

const TapButton = styled.button`
  height: 41px;
  padding: 12px;
  font-family: 'Speedee Bold';
  font-size: 18px;
  line-height: 0.95;
  letter-spacing: -0.05em;
  color: #000000;
  white-space: nowrap;
  border: none;
  border-radius: 4px;
  box-shadow: inset 0px -4px 0px rgba(0, 0, 0, 0.25);

  &:nth-child(3),
  &:nth-child(4),
  &:nth-child(5) {
    background: #A9C23F;
  }

  &:nth-child(1),
  &:nth-child(8) {
    background: #E6A65D;
  }

  &:nth-child(2) {
    background: #C96241;
  }

  &:nth-child(6),
  &:nth-child(7) {
    background: #FFBC0D;
  }

  &:disabled {
    background: #E5E5E5;
    box-shadow: none;
  }

  ${({ selected }) => selected && `
    color: #6C6C6C;
    background: #E5E5E5;
  `}
`;

const Curtain = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 187px);
  background: #FFBC0D;
  transform: scaleY(0);
  transform-origin: center top;

  img {
    position: absolute;
    top: 99%;
    width: 100vw;
  }
`;

const TimerText = styled.div`
  position: absolute;
  left: 60px;
  top: 72px;
  font-family: 'Speedee Bold';
  font-size: 104px;
  line-height: 95%;
  font-weight: bold;
  text-align: center;
  letter-spacing: -0.03em;
  color: #2D2D2D;
  box-sizing: border-box;
`;

const SelectedPhrase = styled.div`
  position: relative;
  top: 150px;
  width: 100%;
  font-family: 'Speedee Bold';
  font-size: 40px;
  line-height: 95%;
  letter-spacing: -0.03em;
  font-weight: bold;
  color: #2D2D2D;
  box-sizing: border-box;
`;

function TimerTap({ ...props }) {
  const { correctPhrase, setTapOptions, tapPhrase, setTapPhrase, attemptCount, setPage } = props;
  const [timerStarted, setTimerStarted] = useState(false);
  const [availableCommas, setAvailableCommas] = useState(5);
  const [availableOptions, setAvailableOptions] = useState(7);
  const [timer, setTimer] = useState(4);

  const selectOption = useCallback(e => {
    e.target.disabled = true;

    setTapPhrase(prev => {
      const currOption = e.target.textContent;
      if (currOption !== 'On a') {
        setAvailableCommas(prev => prev - 1);
      }
      const punctuation = availableOptions === 0 ? '.' : (currOption !== 'On a' && availableCommas > 0 ? ',' : '');
      const currOptionFormatted = (!prev ? currOption : currOption.toLowerCase()) + punctuation;
      setTapOptions(prev => [...prev, currOptionFormatted]);
      setAvailableOptions(prev => prev - 1);
      return prev + currOptionFormatted + (punctuation !== '.' ? ' ' : '');
    });
  }, [setTapPhrase, availableOptions, setAvailableOptions, availableCommas, setAvailableCommas, setTapOptions]);

  useEffect(() => {
    const startTimer = () => {
      setTimer(4);

      const interval = setInterval(() => {
        setTimer(prev => {
          const newTime = prev - 0.01;
          if (newTime <= 0) {
            clearInterval(interval);
            return 0;
          }
          return newTime;
        });
      }, 10);
    };

    if (!timerStarted) {
      setTimerStarted(true);
      setTimer(4);
      startTimer();
    }

    if (correctPhrase === tapPhrase) {
      setPage('success');
      window.gtag('event', `chant_success_tap_${attemptCount + 1}`);
    } else {
      if (availableOptions < 0 || timer <= 0) {
        setPage('try-again-tap');
        window.gtag('event', `chant_failure_tap_${attemptCount + 1}`);
        if (attemptCount >= 7 ) {
          setPage('success');
          window.gtag('event', `chant_failure_tap_${attemptCount + 1}`);
        }
      }
    }
  }, [timerStarted, setTimerStarted, timer, setTimer, attemptCount, setPage, correctPhrase, tapPhrase, availableOptions]);

  return (
    <>
      <Curtain style={{ transform: `scaleY(${1 - timer / 4})` }}><img src={CheeseDrip} alt="Cheese Drip"></img></Curtain>
      <TimerText style={{ color: timer <= 0 ? '#DB0007' : '#2D2D2D' }}>0{timer.toFixed(2)}</TimerText>
      <SelectedPhrase>{tapPhrase}</SelectedPhrase>
      <TapButtonPanel>
        <TapButton key={1} onClick={selectOption}>Two all-beef patties</TapButton>
        <TapButton key={2} onClick={selectOption}>Special sauce</TapButton>
        <TapButton key={3} onClick={selectOption}>Lettuce</TapButton>
        <TapButton key={4} onClick={selectOption}>Cheese</TapButton>
        <TapButton key={5} onClick={selectOption}>Pickles</TapButton>
        <TapButton key={6} onClick={selectOption}>On a</TapButton>
        <TapButton key={7} onClick={selectOption}>Onions</TapButton>
        <TapButton key={8} onClick={selectOption}>Sesame seed bun</TapButton>
      </TapButtonPanel>
    </>
  );
}

export default TimerTap;